import { useCrudOperation } from "@/composables";

const { update } = useCrudOperation();

export default {
  SET_ALL_CANDIDATE(state, payload) {
    state.candidate = {
      items: payload.data,
      totalItems: payload.count,
    };
  },
  SET_GET_CANDIDATES(state, data) {
    state.candidates = data;
  },
  UPDATE_CANDIDATES(state, data) {
    update(state.candidate.items, data);
  },
  SET_ALL_JOBPOSTS(state,payload){
    state.jobposts = {
      items: payload.data,
      totalItems: payload.count,
    };
  },
  SET_CANDIDATE_PROFILE(state, candidateProfile){
    state.candidateProfile = candidateProfile;
  },
  SET_APPLIED_JOBS(state,data){
    state.jobApplies = {
      items: data.data,
      totalItems:data.count
    }
  },
  SET_ALL_COMP_LIST(state,data){
    state.compListForCand = {
      items: data.data,
      totalItems:data.count
    }
  }
};
